import { TwScope } from "./TwScope";
import { Button } from "./common/button";

interface ConnectionErrorProps {
  onRetry: () => void;
}

// Shown when the session cannot be restored because the server is unreachable. The session is
// kept, so retrying can succeed without signing in again.
export const ConnectionError = ({ onRetry }: ConnectionErrorProps) => (
  <TwScope className="tw-flex tw-min-h-screen tw-items-center tw-justify-center tw-px-4">
    <div className="tw-flex tw-w-full tw-max-w-sm tw-flex-col tw-items-center tw-gap-4 tw-text-center">
      <h1 className="tw-text-lg tw-font-semibold">Can&apos;t connect</h1>
      <p className="tw-text-sm tw-text-muted-foreground">
        We couldn&apos;t reach the server to restore your session. Check your connection and try
        again.
      </p>
      <Button onClick={onRetry} className="tw-w-full sm:tw-w-auto">
        Retry
      </Button>
    </div>
  </TwScope>
);
